var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShapes = function SvgShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 11.5 4 6h-8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 14.5,
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.536 2.5 9.07 6.036 5.536 9.57 2 6.036zM11 3h6v6h-6z"
  })));
};
export { SvgShapes as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTQgMTEuNUwxOCAxNy41SDEwTDE0IDExLjVaIiAvPgo8Y2lyY2xlIGN4PSI1LjUiIGN5PSIxNC41IiByPSIzIiAvPgo8cmVjdCB4PSI1LjUzNTY0IiB5PSIyLjUiIHdpZHRoPSI1IiBoZWlnaHQ9IjUiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDUuNTM1NjQgMi41KSIgLz4KPHJlY3QgeD0iMTEiIHk9IjMiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIC8+Cjwvc3ZnPgo=";